<template>
  <v-card>
    <v-card-title>
      <h4>User Information</h4>
    </v-card-title>
    <v-divider></v-divider>
    <v-list dense>
      <v-list-item>
        <v-list-item-content>Referral Code:</v-list-item-content>
        <v-list-item-content class="align-end">{{ user == null ? '' : user.referralCode }}</v-list-item-content>
      </v-list-item>
      <hr style="margin-left: 20px; margin-right: 20px;"/>
      <v-list-item>
        <v-list-item-content>Created Date:</v-list-item-content>
        <v-list-item-content class="align-end">{{ user == null ? '' : formatDate(user.createdDate) }}</v-list-item-content>
      </v-list-item>
      <hr style="margin-left: 20px; margin-right: 20px;"/>
      <v-list-item>
        <v-list-item-content>Terms Accepted:</v-list-item-content>
        <v-list-item-content class="align-end">{{ user == null ? '' : formatDate(user.termsAccepted) }}</v-list-item-content>
      </v-list-item>
      <hr style="margin-left: 20px; margin-right: 20px;"/>
      <v-list-item>
        <v-list-item-content>Privacy Accepted:</v-list-item-content>
        <v-list-item-content class="align-end">{{ user == null ? '' : formatDate(user.privacyAccepted) }}</v-list-item-content>
      </v-list-item>
      <hr style="margin-left: 20px; margin-right: 20px;"/>
      <v-list-item>
        <v-list-item-content>Groups:</v-list-item-content>
        <v-list-item-content class="align-end">
        <v-container v-for= "item in jarresponse" :key="item.id">{{ user == null ? '' : item.code }}</v-container></v-list-item-content>
      </v-list-item>
      <hr style="margin-left: 20px; margin-right: 20px;"/>
      <v-list-item>
        <v-list-item-content class="ma-0 pa-0">Email Verified:</v-list-item-content>
        <v-list-item-content class="ma-0 pa-0"><v-switch disabled="isDisabled" v-model="this.showToggle" color="primary" class="ma-0 pa-0 pt-4" @change="emailVerifiedToggle($event)"></v-switch></v-list-item-content>
        <v-list-item-content><v-btn v-if="!verifyValue" @click="apiCall(!verifyValue)">Verify</v-btn></v-list-item-content>
      </v-list-item>
      <hr style="margin-left: 20px; margin-right: 20px;"/>
      <v-list-item>
        <v-list-item-content class="ma-0 pa-0">User Blacklisted:</v-list-item-content>
        <v-list-item-content class="ma-0 pa-0">
          <v-switch v-model="user.blacklisted" class="ma-0 pa-0 pt-4" color="primary" @change="updateBlacklist"></v-switch>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    emailVerifiedFlag: false,
    verifyValue: false,
    showToggle: false,
    isDisabled: true,
    jarresponse: []
  }),
  watch: {
    // user: {
    //   immediate: true,
    //   deep: true,
    //   handler (newValue, oldValue) {
    //     // this.load
    //   }
    // }
  },
  created () {
    if (this.user.emailVerified === true) {
      this.emailVerifiedFlag = true
      this.showToggle = true
      this.verifyValue = true
    }
    this.jarapicall()
  },
  methods: {
    async emailVerifiedToggle (a) {
      if (
        this.user === undefined ||
        this.user.userId == null ||
        this.user.userId === ''
      ) {
        return
      }

      if (this.emailVerifiedFlag) {
        this.emailVerifiedFlag = true
        this.verifyValue = a
      } else {
        this.emailVerifiedFlag = false
        this.verifyValue = a
      }
    },

    async apiCall (a) {
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/${this.user.userId}/verify`
      var body = { 'quberUserName': this.user.quberUserName,
        'emailVerified': a }
      this.verifyValue = !this.verifyValue
      this.showToggle = !this.showToggle

      var getResponse = await rh.default.patch(endpoint, body, true).catch(e => {
        this.errors.push(e)
      })
    },
    async updateBlacklist (a) {
      if (this.user.blacklisted) {
        var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/blacklist`
        var body = { 'userId': this.user.userId }
        var getResponse = await rh.default.post(endpoint, body, true).catch(e => {
          this.errors.push(e)
        })
      } else if (!this.user.blacklisted) {
        var endpoint2 = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/${this.user.userId}/blacklist`
        var getResponse2 = await rh.default.delete(endpoint2, true).catch(e => {
          this.errors.push(e)
        })
      }
    },
    async jarapicall () {
      this.jarresponse = this.user.groups
    },
    formatDate (aDate) {
      return moment(String(aDate)).format('MM/DD/YYYY hh:mm:ss')
    }

  }
}
</script>
<style>
</style>
